module.exports = __webpack_public_path__ + "static/media/3i_old.37b55396.png";